import { Observable } from 'rxjs'
import { interval as intervalObs } from 'rxjs'
import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

import mergeDescriptors from '../../utils/merge-descriptors.js'
import compiler from '../../mixins/compilers/_compiler.js';
import sourceContainer from '../../mixins/containers/source-container.js';

const methods = {
	beforeInit () {
      return intervalObs(100)
        .pipe(skipWhile(() => !this.$map))
        .pipe(skipWhile(() => !this.$legendContainer))
        .pipe(firstObs())
        .pipe(mapObs(() => this))
        .toPromise(Promise)
    },
 	legendInit () {
       return intervalObs(100)
         .pipe(skipWhile(() => !this.$legendContainer))
         .pipe(firstObs())
         .pipe(mapObs(() => this))
         .toPromise(Promise)
     },
	mountTools () {
		// console.log("mountTools&&&&&&&&&&&&&&&&&&&&")
		// console.log(this.getServices())
	},
	getServices () {
		const vm = this;
		// console.log("Compiling services")
		return mergeDescriptors(
			compiler.methods.getServices.call(vm),
			// sourceContainer.methods.getServices.call(vm),
			{
				get toolbarContainer () { return vm },
			}
		)
	}
}

export default {
	methods,
	mixins: [compiler]
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/toolbar/toolbar-container.js